import React from "react"
import clsx from "clsx"
import MDReactComponent from "markdown-react-js"
import MarkdownItMultimdTable from "markdown-it-multimd-table"
import { Card, CardHeader, CardContent, Divider, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyle = makeStyles(theme => ({
  card: {
    maxWidth: "345px",
    width: "100%",
    height: "120px",
    margin: "auto",
    cursor: "pointer",
  },
  cardHeader: {
    backgroundColor: "#FFF",
    height: "51px",
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingTop: "4px",
    paddingBottom: "4px",
    whiteSpace: "pre-line",
  },
  cardHeaderTitle: {
    fontSize: "14px",
    maxHeight: "41px",
    wordBreak: "normal",
    color: "rgba(0,0,0,0.85)",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "21px",
    overflow: "hidden",
  },
  divider: {
    height: "2px",
    marginLeft: "8px",
    marginRight: "8px",
    borderRadius: "8px",
    backgroundColor: "#D2203E",
  },
  content: {
    position: "relative",
    height: "67px",
    whiteSpace: "pre-line",
    wordBreak: "normal",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    padding: "unset",
  },
  contentFont: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 23,
    right: 23,
    margin: "auto",
    maxHeight: "35px",
    overflow: "hidden",
    fontSize: "14px",
    color: "#727272",
    lineHeight: "18px",
    "& p": {
      margin: 0,
    },
  },
}))

const AgreementCard = ({ name, detail, index, onClick }) => {
  const classes = useStyle()

  const tagSetting = {
    html: "div",
  }
  const blockTextLayoutTags = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "li",
    "pre",
  ]
  const unwrapLayoutTags = ["em", "strong", "code", "ul", "ol"]
  const hiddenLayoutTags = ["img", "hr", "table"]
  const linkTextLayoutTags = ["a"]

  const handleIterate = (Tag, props, children) => {
    if (props.colspan) {
      props = {
        ...props,
        colSpan: props.colspan,
      }
      delete props.colspan
    }

    if (props.rowspan) {
      props = {
        ...props,
        rowSpan: props.rowspan,
      }
      delete props.rowspan
    }

    if (blockTextLayoutTags.find(item => item === Tag)) {
      return <div {...props}>{children}</div>
    } else if (unwrapLayoutTags.find(item => item === Tag)) {
      return children
    } else if (hiddenLayoutTags.find(item => item === Tag)) {
      return ""
    } else if (linkTextLayoutTags.find(item => item === Tag)) {
      return children && children.length > 0 ? children : props.href
    } else {
      return <Tag {...props}>{children}</Tag>
    }
  }

  return (
    <Card
      className={classes.card}
      onClick={onClick}
      data-testid="agreementcard"
      elevation={2}
    >
      <CardHeader
        className={clsx(classes.cardHeader, "agreementcardHeader")}
        titleTypographyProps={{ className: classes.cardHeaderTitle }}
        title={name}
        id={"cardName" + index}
      />
      <Divider className={classes.divider} />
      <CardContent className={clsx(classes.content, "agreementcardContent")}>
        <Box className={classes.contentFont} id={"cardDetail" + index}>
          <MDReactComponent
            text={detail || ""}
            onIterate={handleIterate}
            tags={tagSetting}
            plugins={[
              { plugin: MarkdownItMultimdTable, args: [{ rowspan: true }] },
            ]}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default AgreementCard
